(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["video"] && !Shopify.designMode) return;
  try {
    
  class DeferredMedia extends HTMLElement {
    constructor () {
      super()
      const poster = this.querySelector('[id^="Deferred-Poster-"]')
      if (!poster) return
      poster.addEventListener('click', this.loadContent.bind(this))
    }

    loadContent () {
      if (!this.getAttribute('loaded')) {
        const content = document.createElement('div')
        content.appendChild(this.querySelector('template').content.firstElementChild.cloneNode(true))

        this.setAttribute('loaded', true)
        this.appendChild(content.querySelector('video, model-viewer, iframe')).focus()
      }
    }
  }
  if (!customElements.get('deferred-media')) {
    customElements.define('deferred-media', DeferredMedia)
  }

  } catch(e) { console.error(e); }
})();
})();
